var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"body"},[_c('Hero',{attrs:{"heroIcon":_vm.heroIcon}}),_c('h2',{staticClass:"titleTextAndMargin"},[_vm._v("We make the most incredible little worlds!")]),_c('GameCardList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }